import { render, staticRenderFns } from "./users.vue?vue&type=template&id=04a8fa26&scoped=true"
import script from "./users.vue?vue&type=script&lang=js"
export * from "./users.vue?vue&type=script&lang=js"
import style0 from "./users.vue?vue&type=style&index=0&id=04a8fa26&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a8fa26",
  null
  
)

export default component.exports